import { render } from "./WeeklyReport.vue?vue&type=template&id=58ec7dbf&scoped=true"
import script from "./WeeklyReport.vue?vue&type=script&lang=js"
export * from "./WeeklyReport.vue?vue&type=script&lang=js"

import "./WeeklyReport.vue?vue&type=style&index=0&id=58ec7dbf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ec7dbf"]])

export default __exports__